module.exports = __webpack_public_path__ + "static/media/ipoa1.48a3ca3f.jpg";